import { Button, ButtonVariant, Icon } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ITitleProps } from "../section/Title"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ICurrentEditType } from "./landing-edit-modal"

/* Protopia Ecosystem component */
export interface ITitleDummyProps extends ITitleProps {
   
}
const DescriptionDummy = (props: ITitleDummyProps): JSX.Element => {
    const onClick = () => {
        alert( "CLICK" )
        useLandingStore.setState({ 
            curEditModal: { 
                ...props.section.description, 
                sectionId: props.section.id, 
                currentEditType: SELECT_TYPE.DESCRIPTION
            } as ICurrentEditType
        }) 
    }
    return  props.section.description?.text 
        ?
        <></>
        :
        <Button variant={ ButtonVariant.OUTLINED } className='btn-stretch p-0 pe-title-dummy' onClick={onClick}>
            <div className="micro text-uppercase letter-spacing-1 px-3 py-2 bg-plain-opacity ">
                <Icon  icon="edit" className="mr-1" size={11} />
                { __( "Insert Description" ) }
            </div>
        </Button>
}
export default DescriptionDummy